(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './convertStringMethod'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./convertStringMethod'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convertStringMethod);
    global.trim = mod.exports;
  }
})(this, function (exports, _convertStringMethod) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.trim = undefined;


  /**
   * Replaces by former string stripped of whitespaces at start and end.
   * @function
   * @memberof string
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example trim({ nested: { a: '   Hello world !   ' } }) // => { nested: { a: 'Hello world !' } }
   * @see {@link https://mdn.io/String.prototype.trim|String.prototype.trim} for more information.
   * @since 1.0.0
   */
  var trim = (0, _convertStringMethod.convertStringMethod)('trim');

  exports.trim = trim;
});